import { SpaqFireDb } from './spaq-fire-db.service';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AccountStatusState } from './shared-constants';
import { EMPTY } from 'rxjs';
import { map, skip, switchMap } from 'rxjs/operators';

@Injectable()
export class MonerisService {
	constructor(
		private db: SpaqFireDb,
		private auth: AngularFireAuth
	) {}
	getLastElement(arr) {
		if (arr.length === 0) {
			return null; // ou undefined, selon ce que vous préférez
		}
		return arr[arr.length - 1];
	}
	hydrate() {
		return this.auth.user.pipe(
			switchMap(u =>
				u
					? this.db.userMonerisVault$<AccountStatusState>(u.uid).pipe(
							map(x => (x ? this.getLastElement(Object.values(x)) : null)),
							skip(1)
						)
					: EMPTY
			)
		);
	}
}
